import './App.css';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

function Purchases() {

    return (
        <div  >
            <Card>
                <CardContent >
                    <br />
                    <div>
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input type="hidden" name="hosted_button_id" value="P5UPBUZC56TKQ" />
                            <table>
                                <tr>
                                    <td className="Purchase-header"><input type="hidden" name="on0" value="GDS Google Map WinForms" />
                                        GDS Google Map WinForms
                                    </td>
                                    <td className="Purchase-selection">
                                        <select name="os0">
                                            <option value="Map WinForms Permanent 1 Seat">
                                                Permanent 1 Developer Seat US$300.00
                                            </option>
                                            <option value="Map WinForms Permanent 3 Seats">
                                                Permanent 3 Developer Seats US$600.00
                                            </option>
                                            <option value="Map WinForms Permanent 5 Seats">
                                                Permanent 5 Developer Seats US$900.00
                                            </option>
                                            <option value="Map WinForms Permanent Unlimited Seats">
                                                Permanent Unlimited Developer Seats US$1,200.00
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="hidden" name="currency_code" value="USD" />
                                    </td>
                                    <td>
                                        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Buy Now" />
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </div>
                    <br />
                    <div>
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input type="hidden" name="hosted_button_id" value="JGVTJ4TANKSP4" />
                            <table>
                                <tr>
                                    <td className="Purchase-header"><input type="hidden" name="on0" value="GDS Google Map WinForms" />
                                        GDS Google Map WinForms
                                    </td>
                                    <td className="Purchase-selection">
                                        <select name="os0">
                                            <option value="Map WinForms Annual 1 Seat">
                                                Annual 1 Developer Seat US$500.00
                                            </option>
                                            <option value="Map WinForms Annual 3 Seats">
                                                Annual 3 Developer Seats US$1,000.00
                                            </option>
                                            <option value="Map WinForms Annual 5 Seats">
                                                Annual 5 Developer Seats US$1,500.00
                                            </option>
                                            <option value="Map WinForms Annual Unlimited Seats">
                                                Annual Unlimited Developer Seats US$2,000.00
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="hidden" name="currency_code" value="USD" />
                                    </td>
                                    <td>
                                        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Buy Now" />
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </div>
                    <br />
                    <div>
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input type="hidden" name="hosted_button_id" value="9B23R9DRX3C8W" />
                            <table>
                                <tr>
                                    <td className="Purchase-header"><input type="hidden" name="on0" value="GDS Google Map WPF" />
                                        GDS Google Map WPF
                                    </td>
                                    <td className="Purchase-selection">
                                        <select name="os0">
                                            <option value="Map WPF Permanent 1 Seat">
                                                Permanent 1 Developer Seat US$300.00
                                            </option>
                                            <option value="Map WPF Permanent 3 Seats">
                                                Permanent 3 Developer Seats US$600.00
                                            </option>
                                            <option value="Map WPF Permanent 5 Seats">
                                                Permanent 5 Developer Seats US$900.00
                                            </option>
                                            <option value="Map WPF Permanent Unlimited Seats">
                                                Permanent Unlimited Developer Seats US$1,200.00
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="hidden" name="currency_code" value="USD" />
                                    </td>
                                    <td>
                                        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Buy Now" />
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </div>
                    <br />
                    <div>
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input type="hidden" name="hosted_button_id" value="JC2JT2UR9TV6Y" />
                            <table>
                                <tr>
                                    <td className="Purchase-header"><input type="hidden" name="on0" value="GDS Google Map WPF" />
                                        GDS Google Map WPF
                                    </td>
                                    <td className="Purchase-selection">
                                        <select name="os0">
                                            <option value="Map WPF Annual 1 Seat">
                                                Annual 1 Developer Seat US$500.00
                                            </option>
                                            <option value="Map WPF Annual 3 Seats">
                                                Annual 3 Developer Seats US$1,000.00
                                            </option>
                                            <option value="Map WPF Annual 5 Seats">
                                                Annual 5 Developer Seats US$1,500.00
                                            </option>
                                            <option value="Map WPF Annual Unlimited Seats">
                                                Annual Unlimited Developer Seats US$2,000.00
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="hidden" name="currency_code" value="USD" />
                                    </td>
                                    <td>
                                        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Buy Now" />
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </div>
                    <br />
                    <div>
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input type="hidden" name="hosted_button_id" value="B4R83GTL639TU" />
                            <table>
                                <tr>
                                    <td className="Purchase-header">
                                        <input type="hidden" name="on0" value="GDS Easy MQ"/>
                                            GDS Easy MQ
                                    </td>
                                    <td className="Purchase-selection">
                                        <select name="os0">
                                            <option value="Easy MQ Permanent 1 Seat">
                                                Permanent 1 Developer Seat US$300.00
                                            </option>
                                            <option value="Easy MQ Permanent 3 Seats">
                                                Permanent 3 Developer Seats US$600.00
                                            </option>
                                            <option value="Easy MQ Permanent 5 Seats">
                                                Permanent 5 Developer Seats US$900.00
                                            </option>
                                            <option value="Easy MQ Permanent Unlimited Seats">
                                                Permanent Unlimited Developer Seats US$1,200.00
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="hidden" name="currency_code" value="USD" />
                                    </td>
                                    <td>
                                        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Buy Now" />
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </div>
                    <br />
                    <div>
                        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input type="hidden" name="hosted_button_id" value="UD83MZMYFMBM4" />
                            <table>
                                <tr>
                                    <td className="Purchase-header">
                                        <input type="hidden" name="on0" value="GDS Easy MQ"/>
                                        GDS Easy MQ
                                    </td>
                                    <td className="Purchase-selection">
                                        <select name="os0">
                                            <option value="Easy MQ Annual 1 Seat">
                                                Annual 1 Developer Seat US$500.00
                                            </option>
                                            <option value="Easy MQ Annual 3 Seats">
                                                Annual 3 Developer Seats US$1,000.00
                                            </option>
                                            <option value="Easy MQ Annual 5 Seats">
                                                Annual 5 Developer Seats US$1,500.00
                                            </option>
                                            <option value="Easy MQ Annual Unlimited Seats">
                                                Annual Unlimited Developer Seats US$2,000.00
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="hidden" name="currency_code" value="USD" />
                                    </td>
                                    <td>
                                        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Buy Now" />
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </div>
                    <br />
                    <p className='Purchase-paypal-note'>PayPal takes credit card, thus you don't need to have a PayPal account to buy!</p>
                    <p className="Purchase-body">You will receive your license key through email by the end of next business day after your purchase.</p>
                </CardContent>
            </Card>
        </div>
    );
}

export default Purchases;
